import React, { Component, Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import AppRoutesEn from './AppRoutesEn';
import Layout from './components/Layout';
import { Layout_En } from './components/Layout_En';
import Error from './components/Error';
import PrivateRoute from './components/PrivateRoute';
import CirculationRoute from './components/CirculationRoute';
import { CirculationContextProvider } from './components/common/config/CirculationContext';

import './custom.css';
import ReactGA from 'react-ga4';
export default class App extends Component {
    static displayName = App.name;

    constructor(prop) {
        super(prop);


    }

    componentDidMount() {

        ReactGA.initialize(process.env.REACT_APP_GA);

        /*
         , {
            gaOptions: {
                cookieFlags: 'SameSite=Strict;Secure;Max-Age=3600;HttpOnly'
            }
        }
         */

    }

    render() {




        return (
            <CirculationContextProvider>
                <Routes>
                    <Route element={<Layout />}>
                        {AppRoutes.map((route, index) => {
                            const { element, ...rest } = route;
                            return <Route key={index}  {...rest} element={<CirculationRoute>{element}</CirculationRoute>} />;
                        })}
                    </Route>

                    <Route element={<Layout_En />}>
                        {AppRoutesEn.map((route, index) => {
                            const { element, ...rest } = route;
                            return <Route key={index}  {...rest} element={<CirculationRoute>{element}</CirculationRoute>} />;
                        })}
                    </Route>

                    <Route path="*" element={<Error />}></Route>
                </Routes>
            </CirculationContextProvider>
        );

    }
}
